const { assetRoot } = window;
// eslint-disable-next-line no-undef,no-global-assign,camelcase,@typescript-eslint/camelcase
__webpack_public_path__ = assetRoot.endsWith('/') ? assetRoot : `${assetRoot}/`;
